module.exports = __webpack_public_path__ + "static/logo-374dc27ece2a0fc2e0437b1de862965d.jpg";